import MainLayout from '@/components/layouts/main-layout';
import {useRouter} from 'next/router';

export default function PrivacyPolicyPage() {
  const {locale} = useRouter();
  return (
    <MainLayout metadata={{title: 'Privacy Policy - Soubul'}}>
      <div className="flex flex-1 items-center justify-center">
        {locale === 'ar' ? <ArabicPrivacyPolicy /> : <EnglishPrivacyPolicy />}
      </div>
    </MainLayout>
  );
}

function EnglishPrivacyPolicy() {
  return (
    <div className="bg-white border rounded-lg text-center my-12 px-6 py-12">
      <h1 className="text-3xl mb-12">Privacy Policy</h1>
      <div className="container mx-auto text-justify" style={{maxWidth: '720px'}}>
        <span className="font-semibold block mb-4">Privacy Policy</span>
        <span className="block mb-6 text-sm">
          This Privacy Policy is designed to help you understand how{' '}
          <span className="font-semibold">SOUBUL ACADEMY</span> collects, transmits, and stores information about our
          Users. The term “you” or “User” or “service provider” shall refer to Students, Tutors or any person or entity
          who views, uses, accesses, browses, or submits any content or material to the Service (defined below). This
          Privacy Policy is not a contract and does not create any legal rights. Providing your information is voluntary
          and your use of the Service (defined below) after the effective date of this document constitutes your
          acceptance of this Privacy Policy. If you do not agree to all the terms and conditions of this Privacy Policy,
          do not use the Service.
        </span>

        <span className="block mb-4 font-semibold">INFORMATION WE COLLECT</span>
        <span className="block mb-4 font-semibold">Information you provide to us:</span>
        <span className="block mb-6 text-sm">
          This Privacy Policy applies only to information we collect via the website www.soubul.com, online and mobile
          applications, email, telephone, electronic devices, and other interactive services. To help you get the most
          out of our service, we collect User submitted personally identifiable information (“PII”) when you use the
          Service. For example we may collect information you provide when you create an account, create or edit your
          profile, upload content (photographs, essays, lessons, etc.), provide profile descriptions or comments,
          provide school information for a student, participate in a contest or promotion, participate in interactive
          features of the Service, connect or communicate with us via third party social media sites, send us an email,
          request customer support or otherwise communicate with us or communicate with others users through the
          Service. Such information may include your name, address, password, zip code, email address, and phone number
          for communication purposes. Information may be submitted to the Site or Apps or via telephone or email when
          communicating with a <span className="font-semibold">SOUBUL ACADEMY</span> representative. For students and
          parents, we may collect information related to your documentation of and payment for tutoring sessions;
          tutoring questions related to homework or your studies; teacher feedback of a student (once the parent
          provides consent for submission); and content you upload for the purposes of transmitting it to another user
          or for public display on the Site or Apps.
        </span>

        <span className="block mb-6 text-sm">
          For service providers, we may collect your national ID and date of birth, for tax purposes or to complete a
          background check; we also collect content you upload for purposes related to transmission to other users or
          public display on the Site or Apps.
        </span>

        <span className="block mb-4 font-semibold">Information we collect automatically:</span>

        <span className="block mb-6 text-sm">
          We also gather non-PII when you use the Service, including type of browser you use, access time, pages viewed,
          your IP address; and we collect information about the computer or mobile device you use to access the Service,
          including without limitation operating system and unique device identifiers and mobile network information.
          This data is used to better understand and enhance the user experience on the Site and Apps{' '}
          <span className="font-semibold">SOUBUL ACADEMY</span> may publish these statistics or share them with third
          parties without including PII.
        </span>

        <span className="block mb-4 font-semibold">Information we collect from other sources:</span>
        <span className="block mb-6 text-sm">
          We may also obtain information from other sources and combine that with information we collect through the
          Service. For example, we may collect information about you from other users, identity verification services,
          credit bureaus, mailing list providers and publicly available sources. If you log into your account through
          sign-in services, like Facebook Connect or Google Authenticator, you provide SOUBUL ACADEMY with permission to
          access certain information about you such as your Facebook User ID, user profile, friends list, user graph and
          profile picture. User generated content posted through certain social networking preferences (e.g., pages you
          “Like” or “Follow”) may be viewed by the public.
        </span>

        <span className="block mb-4 font-semibold">FINANCIAL INFORMATION:</span>

        <span className="block mb-6 text-sm">
          If you elect to pay for services with a credit card, we will collect your name, credit card number, expiration
          date, and address information associated with the account. All financial information, other than credit card
          numbers, is stored and encrypted in our System in full compliance with the Payment Card Industry Data Security
          Standard.
        </span>

        <span className="block mb-6">
          If you are a service provider and elect to pay for a background check, we will collect credit card information
          to order a background check on your behalf. Payment information entered our System solely to procure a
          background check will not be stored on our servers.
        </span>

        <span className="block mb-4 font-semibold">USE OF PERSONALLY IDENTIFIABLE INFORMATION:</span>

        <span className="block mb-6 text-sm">
          <span className="font-semibold">SOUBUL ACADEMY</span> may use PII or other personal information you
          specifically give to us: a) to provide services to you through the System, b) to process transactions and
          billing, c) for identification and authentication purposes, d) to communicate with you concerning the System,
          transactions, security, privacy and administrative issues relating to your use of the System, e) to improve
          your response to and interaction with the System, f) process and deliver contest and sweepstakes entries and
          rewards and verify eligibility; g) to do something you have asked us to do, or tell you of services that we
          think may be of interest to you; h) in the case of teacher feedback of a student, we will transmit it as you
          ask us to; i) personalize and improve the Service and deliver and display targeted advertisements on our
          Service, content or features in the Service and on other sites or apps; and j) to provide third party
          tutor-matching services an opportunity to provide you with information about tutors; and k) for administration
          of and troubleshooting regarding the System. <span className="font-semibold">SOUBUL ACADEMY</span> shares a
          minimum amount of information between tutors and students to facilitate the arrangement of tutoring sessions.
          We reserve the right to release non-personally identifiable information collected in aggregate, however. Third
          parties, including Facebook, may use cookies, web beacons, and other storage technologies to collect or
          receive information from our Site, apps and elsewhere on the internet and use that information to provide
          measurement services and target ads.
        </span>

        <span className="block mb-4 font-semibold">REFERRALS:</span>

        <span className="block mb-6 text-sm">
          If you choose to use our referral service, to tell a friend about our Service, we will ask you for your
          friend’s email address. We will automatically send your friend a one-time email inviting him or her to visit
          the Site and up to two reminders <span className="font-semibold">SOUBUL ACADEMY</span> stores this information
          for the sole purpose of sending this one-time email and reminders and tracking the success of our referral
          program.
        </span>

        <span className="block mb-4 font-semibold">YOUR CHOICES:</span>

        <span className="block mb-6 text-sm">
          Please remember to help keep the Site secure by never sharing your username or password. If you think your
          password may have been compromised, please change it immediately or contact{' '}
          <span className="font-semibold">SOUBUL ACADEMY</span> for additional assistance.
        </span>

        <span className="block mb-4 font-semibold">PRIVACY POLICY CHANGES:</span>

        <span className="block mb-6 text-sm">
          <span className="font-semibold">SOUBUL ACADEMY</span> reserves the right to change this Privacy Policy, from
          time to time, due to modifications to the Site’s features and functionality. We will post any changes here and
          indicate the new effective date of the Privacy Policy at the top of the document. We encourage you to review
          the Privacy Policy for any updates while you are an active User of the Site.
        </span>

        <span className="block mb-4 font-semibold">CONTACT INFORMATION:</span>
        <span className="block mb-4 text-sm">
          Questions regarding this Privacy Policy should be directed to Support@Soubul.com
        </span>
      </div>
    </div>
  );
}

function ArabicPrivacyPolicy() {
  return (
    <div className="bg-white border rounded-lg text-center my-12 px-6 py-12">
      <h1 className="text-3xl mb-12">سياسة الخصوصية</h1>
      <div className="container mx-auto text-justify" style={{maxWidth: '720px'}}>
        <span className="font-semibold block mb-4">سياسة الخصوصية</span>
        <span className="block mb-6 text-sm">
          تم تصميم سياسة الخصوصية هذه لمساعدتك على فهم كيفية تقوم منصة أكاديمية سبل بتجميع ونقل وتخزين معلومات عن
          مستخدمينا. يشير المصطلح "أنت" أو "المستخدم" أو "مقدم الخدمة" إلى الطلاب أو المعلمين أو أي شخص أو كيان يقوم
          بعرض أو استخدام أو الوصول أو تصفح أو إرسال أي محتوى أو مادة إلى الخدمة (المحددة أدناه). سياسة الخصوصية هذه
          ليست عقدًا ولا تنشئ أي حقوق قانونية. يعد تقديم معلوماتك أمرًا طوعيًا واستخدامك للخدمة (المحددة أدناه) بعد
          تاريخ نفاذ هذا المستند يشكل موافقتك على سياسة الخصوصية هذه. إذا كنت لا توافق على جميع شروط وأحكام سياسة
          الخصوصية هذه، فلا تستخدم الخدمة.
        </span>

        <span className="block mb-4 font-semibold">المعلومات التي يتم جمعها</span>
        <span className="block mb-4 font-semibold">المعلومات تقدمها لنا:</span>
        <span className="block mb-6 text-sm">
          تنطبق سياسة الخصوصية هذه فقط على المعلومات التي نجمعها عبر موقع الويب www.soubul.com وعبر تطبيقات الإنترنت
          والهاتف المحمول والبريد الإلكتروني والهاتف والأجهزة الإلكترونية والخدمات التفاعلية الأخرى. من أجل مساعدتك في
          تحقيق أقصى استفادة من خدمتنا، نقوم بجمع معلومات التعريف الشخصية المقدمة من المستخدم ("PII") عند استخدامك
          للخدمة. على سبيل المثال ، قد نقوم بجمع المعلومات التي تقدمها عند إنشاء حساب ، أو إنشاء ملف التعريف الخاص بك أو
          تعديله ، أو تحميل المحتوى (الصور ، والمقالات ، والدروس ، وما إلى ذلك) ، أو تقديم أوصاف أو تعليقات للملف الشخصي
          ، أو تقديم معلومات المدرسة لطالب ، أو المشاركة في مسابقة أو الترويج ، أو المشاركة في الميزات التفاعلية للخدمة
          ، أو الاتصال بنا أو التواصل معنا عبر مواقع التواصل الاجتماعي التابعة لجهات خارجية ، أو إرسال بريد إلكتروني
          إلينا ، أو طلب دعم العملاء أو التواصل معنا بطريقة أخرى أو التواصل مع مستخدمين آخرين من خلال الخدمة. قد تتضمن
          هذه المعلومات اسمك وعنوانك وكلمة المرور والرمز البريدي وعنوان البريد الإلكتروني ورقم الهاتف لأغراض الاتصال.
          يمكن تقديم المعلومات إلى الموقع أو التطبيقات أو عبر الهاتف أو البريد الإلكتروني عند التواصل مع مقدم الخدمة في
          أكاديمية سبل. للمستخدمين، قد نقوم بجمع المعلومات المتعلقة بالوثائق الخاصة بك والدفع مقابل جلسات التدريس؛ أسئلة
          التدريس المتعلقة بالواجب المنزلي أو دراستك؛ ملاحظات المعلم للطالب (بمجرد أن يقدم الوالد الموافقة على التقديم)؛
          والمحتوى الذي تقوم بتحميله لأغراض نقله إلى مستخدم آخر أو للعرض العام على الموقع أو التطبيقات.
        </span>

        <span className="block mb-6 text-sm">
          بالنسبة لمقدمي الخدمة، قد نجمع رقم السجل الوطني أو الإقامة وتاريخ الميلاد، لأغراض ضريبية أو لإكمال فحص أمني؛
          نقوم أيضًا بجمع المحتوى الذي تقوم بتحميله لأغراض تتعلق بنقله إلى مستخدمين آخرين أو عرضه بشكل عام على الموقع أو
          التطبيقات.
        </span>

        <span className="block mb-4 font-semibold">المعلومات يتم جمعها تلقائياً:</span>

        <span className="block mb-6 text-sm">
          نجمع أيضًا معلومات غير معلومات التعريف الشخصية عند استخدام الخدمة، بما في ذلك نوع المتصفح الذي تستخدمه ووقت
          الوصول والصفحات التي تم عرضها وعنوان IP الخاص بك؛ ونجمع معلومات حول الحاسوب أو الجهاز المحمول الذي تستخدمه
          للوصول إلى الخدمة، بما في ذلك على سبيل المثال لا الحصر نظام التشغيل ومعرّفات الجهاز الفريدة ومعلومات شبكة
          الهاتف المحمول. تُستخدم هذه البيانات لفهم وتحسين تجربة المستخدم على الموقع والتطبيقات بشكل أفضل. قد نقم بنشر
          هذه الإحصائيات أو مشاركتها مع أطراف ثالثة دون تضمين معلومات تحديد الهوية الشخصية
        </span>

        <span className="block mb-4 font-semibold">المعلومات التي نجمعها من مصادر أخرى:</span>
        <span className="block mb-6 text-sm">
          قد نحصل أيضًا على معلومات من مصادر أخرى وندمجها مع المعلومات التي نجمعها من خلال الخدمة. على سبيل المثال، قد
          نجمع معلومات عنك من مستخدمين آخرين، وخدمات التحقق من الهوية، وموفري القائمة البريدية، والمصادر المتاحة
          للجمهور. إذا قمت بتسجيل الدخول إلى حسابك من خلال خدمات تسجيل الدخول، مثل Facebook Connect أو Google
          Authenticator، فأنت تقدم لأكاديمية سبل أذن الوصول إلى معلومات معينة عنك مثل معرف مستخدم Facebook وملف تعريف
          المستخدم وقائمة الأصدقاء ومخطط المستخدم وصورة الملف الشخصي. المحتوى الذي ينشئه المستخدم والذي تم نشره من خلال
          تفضيلات معينة للشبكات الاجتماعية (مثل الصفحات التي "تعجبك" أو "متابعة") يمكن مشاهدتها من قبل عامة الناس.
        </span>

        <span className="block mb-4 font-semibold">المعلومات المالية:</span>

        <span className="block mb-6 text-sm">
          إذا اخترت الدفع مقابل الخدمات ببطاقة ائتمان، فسنجمع اسمك ورقم بطاقة الائتمان وتاريخ انتهاء الصلاحية ومعلومات
          العنوان المرتبطة بالحساب. يتم تخزين جميع المعلومات المالية، بخلاف أرقام بطاقات الائتمان، وتشفيرها في نظامنا
          بما يتوافق تمامًا مع معيار أمان بيانات صناعة بطاقات الدفع.
        </span>

        <span className="block mb-6">
          إذا كنت مقدم خدمة، واخترت الدفع مقابل فحص السجلات السابقة، فسنجمع معلومات بطاقة الائتمان لطلب فحص أمني نيابة
          عنك. لن يتم تخزين معلومات الدفع التي يتم إدخالها في نظامنا فقط لإجراء فحص للسجلات على خوادمنا.
        </span>

        <span className="block mb-4 font-semibold">استخدام المعلومات الشخصية:</span>

        <span className="block mb-6 text-sm">
          قد تستخدم أكاديمية سبل معلومات PII أو غيرها من المعلومات الشخصية التي تقدمها لنا على وجه التحديد: لتقديم
          الخدمات لك من خلال النظام ، ب) لمعالجة المعاملات والفواتير ، ج) لأغراض التعريف والمصادقة ، د) للتواصل معك فيما
          يتعلق بالنظام والمعاملات والأمان والخصوصية والمسائل الإدارية المتعلقة باستخدامك للنظام ، هـ) لتحسين استجابتك
          للنظام والتفاعل معه ، و) معالجة وتسليم إدخالات ومكافآت المسابقة واليانصيب والتحقق من الأهلية ؛ ز) القيام بشيء
          ما طلبت منا القيام به ، أو إخبارك بالخدمات التي نعتقد أنها قد تهمك ؛ ح) إضفاء الطابع الشخصي على الخدمة
          وتحسينها وتقديم إعلانات مستهدفة وعرضها على خدمتنا أو المحتوى أو الميزات الموجودة في الخدمة وعلى المواقع أو
          التطبيقات الأخرى ؛ ي) لتوفير خدمات مطابقة للمقدمي الخدمة من طرف ثالث فرصة لتزويدك بمعلومات حول المعلمين ؛ و ك)
          لإدارة واستكشاف الأخطاء وإصلاحها فيما يتعلق بالنظام. أكاديمية سبل تشارك الحد الأدنى من المعلومات بين مقدمي
          الخدمة و المستخدمين من أجل تسهيل ترتيب جلسات التدريس. ومع ذلك، نحتفظ بالحق في الكشف عن المعلومات غير الشخصية
          التي تم جمعها بشكل إجمالي. قد تستخدم الجهات الخارجية، بما في ذلك Facebook، ملفات تعريف الارتباط وإشارات الويب
          وتقنيات التخزين الأخرى لجمع أو تلقي المعلومات من موقعنا وتطبيقاتنا وأماكن أخرى على الإنترنت واستخدام هذه
          المعلومات لتوفير خدمات القياس والإعلانات المستهدفة.
        </span>

        <span className="block mb-4 font-semibold">الإحالات:</span>

        <span className="block mb-6 text-sm">
          إذا اخترت استخدام خدمة الإحالة الخاصة بنا، لإخبار صديق عن خدمتنا، فسنطلب منك عنوان البريد الإلكتروني لصديقك.
          سنرسل تلقائيًا إلى صديقك بريدًا إلكترونيًا لمرة واحدة لدعوته أو دعوتها لزيارة الموقع وما يصل إلى تذكيرَين.
          أكاديمية سبل ستقوم بتخزين هذه المعلومات لغرض وحيد هو إرسال هذا البريد الإلكتروني والتذكير لمرة واحدة وتتبع
          نجاح برنامج الإحالة لدينا.
        </span>

        <span className="block mb-4 font-semibold">اختياراتك:</span>

        <span className="block mb-6 text-sm">
          يرجى الحفاظ على أمان الموقع من خلال عدم مشاركة اسم المستخدم أو كلمة المرور مطلقًا. إذا كنت تعتقد أن كلمة
          المرور الخاصة بك قد تم اختراقها، فيرجى تغييرها على الفور أو الاتصال بأكاديمية سبل للحصول على مساعدة إضافية.
        </span>

        <span className="block mb-4 font-semibold">تغييرات سياسة الخصوصية:</span>

        <span className="block mb-6 text-sm">
          تحتفظ أكاديمية سبل بالحق في تغيير سياسة الخصوصية هذه، من وقت لآخر، بسبب التعديلات على ميزات الموقع ووظائفه.
          سننشر أي تغييرات هنا ونشير إلى تاريخ السريان الجديد لسياسة الخصوصية في الجزء العلوي من المستند. نحن نشجعك على
          مراجعة سياسة الخصوصية لأية تحديثات عندما تكون مستخدمًا نشطًا للموقع.
        </span>

        <span className="block mb-4 font-semibold">معلومات الاتصال:</span>
        <span className="block mb-4 text-sm">
          يجب توجيه الأسئلة المتعلقة بسياسة الخصوصية هذه إلى Support@Soubul.com
        </span>
      </div>
    </div>
  );
}
